import { render, staticRenderFns } from "./Srq20Email.vue?vue&type=template&id=5f4cab3f&"
import script from "./Srq20Email.vue?vue&type=script&lang=js&"
export * from "./Srq20Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports